import type { FC } from 'react'
import type { SxProps, Theme } from '@mui/material'
import { Box } from '@mui/material'
import { MarkdownRenderer } from '../markdown'
import { LazyCollapsibleContent } from './shared'

interface PlanApprovalContextRendererProps {
  readonly plan: string
  readonly enableCollapse?: boolean | undefined
}

export const PlanApprovalContextRenderer: FC<PlanApprovalContextRendererProps> = ({
  plan,
  enableCollapse = true,
}) => {
  return (
    <Box sx={contentSx}>
      <LazyCollapsibleContent content={plan} enableCollapse={enableCollapse}>
        {(displayContent) => (
          <MarkdownRenderer key={`plan-${displayContent.length}`} content={displayContent} />
        )}
      </LazyCollapsibleContent>
    </Box>
  )
}

const contentSx: SxProps<Theme> = {
  mb: 1,
}
